import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';
export const SEEK_TRUTH_WEEKLY_TYPES = [
]

const entityColumns = {
  id: {
    model_name: 'SeekTruthWeekly',
    column_type: 'id',
  },
  created_at: {
    model_name: 'SeekTruthWeekly',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'SeekTruthWeekly',
    column_type: 'datetime',
  },
  title: {
    model_name: 'SeekTruthWeekly',
    column_type: 'string',
  },
  type: {
    model_name: 'SeekTruthWeekly',
    column_type: 'type',
    extra: {
      options: [],
    },
  },
  likes_count: {
    model_name: 'SeekTruthWeekly',
    column_type: 'integer',
  },
  views_count: {
    model_name: 'SeekTruthWeekly',
    column_type: 'integer',
  },
  stars_count: {
    model_name: 'SeekTruthWeekly',
    column_type: 'integer',
  },
  shares_count: {
    model_name: 'SeekTruthWeekly',
    column_type: 'integer',
  },
  comments_count: {
    model_name: 'SeekTruthWeekly',
    column_type: 'integer',
  },
  published_at: {
    model_name: 'SeekTruthWeekly',
    column_type: 'datetime',
  },
  author: {
    model_name: 'SeekTruthWeekly',
    column_type: 'string',
  },
  source: {
    model_name: 'SeekTruthWeekly',
    column_type: 'string',
  },
  share_desc: {
    model_name: 'SeekTruthWeekly',
    column_type: 'string',
  },
  is_top: {
    model_name: 'SeekTruthWeekly',
    column_type: 'boolean',
  },
  content_type: {
    model_name: 'SeekTruthWeekly',
    column_type: 'enum',
  },
  cover: {
    model_name: 'SeekTruthWeekly',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  content: {
    model_name: 'SeekTruthWeekly',
    column_type: 'text',
  },
  markdown_content: {
    model_name: 'SeekTruthWeekly',
    column_type: 'text',
  },
  recommend_posts: {
    model_name: 'SeekTruthWeekly',
    column_type: 'has_many',
    extra: {
      association_name: 'recommend_posts',
      model_name: 'Post',
      foreign_key: 'post_id',
    },
  },
  recommend_post_ids: {
    model_name: 'SeekTruthWeekly',
    column_type: 'has_many',
    extra: {
      association_name: 'recommend_posts',
      model_name: 'Post',
      foreign_key: 'post_id',
    },
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
